import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AskConfirmationOutputData } from '@sc/data-access-models';
import { ButtonComponent, IconComponent } from '@sc/ui-components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sc-ask-confirmation-dialog',
  template: `
    <div class="container">
      <div class="close-icon-container">
        <button (click)="onClose({ type: 'cancel' })">
          <sc-icon name="close"></sc-icon>
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : {
                    dialogTitle:
                      'AskConfirmationDialogComponent.dialogTitle' | translate
                  }
          }}</span>
        </button>
      </div>
      <h1 mat-dialog-title id="ask-confirmation-dialog-id">
        {{ 'AskConfirmationDialogComponent.dialogTitle' | translate }}
      </h1>
      <div class="dialog-content">
        <div class="dialog-body">
          {{ 'AskConfirmationDialogComponent.dialogText' | translate }}
        </div>
        <div class="dialog-actions">
          <sc-button
            buttonType="secondary"
            (click)="onClose({ type: 'cancel' })"
          >
            {{ 'AskConfirmationDialogComponent.cancelBtn' | translate }}
          </sc-button>
          <sc-button buttonType="error" (click)="onClose({ type: 'confirm' })">
            {{ 'AskConfirmationDialogComponent.confirmBtn' | translate }}
          </sc-button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./ask-confirmation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonComponent, TranslateModule, IconComponent],
})
export class AskConfirmationDialogComponent {
  onCloseValue: AskConfirmationOutputData;

  constructor(
    private readonly dialogRef: MatDialogRef<
      AskConfirmationDialogComponent,
      AskConfirmationOutputData
    >
  ) {}

  onClose(closeValue: AskConfirmationOutputData) {
    this.dialogRef.close(closeValue);
  }
}
